import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstanceClient from '../../Common/Axios/axiosInstanceClient';
// import API from "../../Common/Endpoint/serviceConstrants";

// export const onMemberPatch = createAsyncThunk('GetOfferData', async (payload) => {
//     try {
//         const response = await axiosInstanceClient.patch(
//           API.MemberApi, // Add this endpoint to serviceConstrants if not present
//           payload,
//           {
//             headers: {
//               'Content-Type': 'application/json',
//             },
//           }
//         );
//         return response.data;
//       } catch (error) {
//         console.error('Member PATCH failed:', error);
//         return null;
//       }
//   });


export const MemberSlice = createSlice({
  name: "get-member ",
  initialState: {
    isLoading: false,
    isError: false,
    MemberData: [],
    message: "",
    isgetLoading: false,
  },
  reducers: {
    onGetMember: (state) => {
      return {
        ...state,
        isgetLoading: false,
        MemberData: [],
        getmessage: "",
      };
    },

    onGetMemberSuccess: (state, { payload }) => {
      return {
        ...state,
        isgetLoading: false,
        MemberData: payload?.data,
        getmessage: "",
        get_status_code: "200",
      };
    },

    onGetMemberError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        MemberData: data,
        getmessage: message,
        get_status_code: status_code,
        isgetLoading: false,
      };
    },
    onGetMemberReset: (state) => {

      return {
        ...state,
        get_status_code: null,
        isgetLoading: false,
      };

    },
    onGetMemberData: (state) => {
      return {
        ...state,
        isgetMemberLoading: false,
        getMemberData: [],
        getmembermessage: "",
      };
    },

    onGetMemberDataSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isgetMemberLoading: false,
        getMemberData: data,
        getmembermessage: message,
        get_member_status_code: status_code,
      };
    },

    onGetMemberDataError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        getMemberData: data,
        getmembermessage: message,
        get_member_status_code: status_code,
        isgetMemberLoading: false,
      };
    },
    onGetMemberDataReset: (state) => {

      return {
        ...state,
        get_member_status_code: null,
        isgetMemberLoading: false,
      };

    },
    onGetMemberLogout: (state) => {
      return {
        ...state,
        MemberData: null,
        get_status_code: null,
        isgetLoading: false,
      };

    },
    onPostMember: (state, action) => {
      return {
        ...state,
        isPostLoading: false,
        postMemberData: action?.payload,
      };
    },

    onPostMemberSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isPostLoading: false,
        postMemberData: postData,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostMemberError: (state, { payload }) => {
      const { postData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        postMemberData: postData,
        postMessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostMemberReset: (state) => {
      return {
        ...state,
        postMemberData: [],
        postMessage: "",
        post_status_code: null
      };
    },

  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(onMemberPatch.pending, (state, action) => {
  //       state.isLoading = true;
  //     })
  //     .addCase(onMemberPatch.fulfilled, (state, action) => {
  //       state.isLoading = false;
  //     })
  //     .addCase(onMemberPatch.rejected, (state, action) => {
  //       state.isLoading = false;
  //     });
  // }
});

export const {
  onGetMember,
  onGetMemberSuccess,
  onGetMemberError,
  onGetMemberReset,
  onGetMemberLogout,
  onPostMember,
  onPostMemberSuccess,
  onPostMemberError,
  onPostMemberReset,
  onGetMemberData,
  onGetMemberDataError,
  onGetMemberDataSuccess,
  onGetMemberDataReset
} = MemberSlice.actions;

export default MemberSlice.reducer;
